import axios from "axios";
import { apiUrl, getAuthHeader } from "./base";

const path = "/apisupervision";

type SortOption = {
  field: 'student' | 'programme' | 'cohort' | null;
  direction: 'asc' | 'desc' | null;
}

const getOverview = async (type: string, groupIds: string, sort?: SortOption, page?: number, perPage?: number) => {
  let ret = { data: [], totalCount: 0 };

  try {
    let targetUrl = `${path}/overview/${type}/${groupIds}`;
    const params = new URLSearchParams();

    // Attach sort query parameter if provided
    if (sort?.field && sort?.direction) {
      params.append('sort', `${sort.field} ${sort.direction}`);
    }

    // Attach pagination parameters if provided
    if (page) {
      params.append('page', page.toString());
    }
    if (perPage !== undefined) {
      params.append('perPage', perPage.toString());
    }

    if (params.toString()) {
      targetUrl += `?${params.toString()}`;
    }

    let req = await axios.get(apiUrl(targetUrl), await getAuthHeader());
    let res = req.data;
    if (res.result === "OK") {
      ret.data = Array.isArray(res.data) ? res.data : [];
      ret.totalCount = res.totalCount || 0;
    }
  } catch {
    //ignore
  }

  return ret;
};

const ApiSupervision = { getOverview };

export default ApiSupervision;
